import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from '../modal.service';

declare var $ : any;

/**
 * This class represents the notify (service version of info) modal component
 */
@Component({
    selector: 'notify-modal',
    templateUrl: 'notify-modal.component.html',
    standalone: false
})

export class NotifyModalComponent implements OnInit{
	
    private _confirmBtn: HTMLElement;
    private _closeBtn: HTMLElement;

    constructor(modalService: ModalService){
      
        modalService.notify = this.notify.bind(this);  
    }

	translateSrc: string;
	title: string;
    buttonText : string;

    ngOnInit() {
        this._confirmBtn = document.getElementById('notifyBtn');
        this._closeBtn = document.getElementById('btnCloseNotify');
    }
     
   notify(msgKey: string, title: string, buttonText: string): Promise<boolean> {
        this.translateSrc = msgKey;
        this.title = title;
        this.buttonText = buttonText;
         $('#notifyInfo').modal('show');
        let promise = new Promise<boolean> (resolve => {
            this._configureNotifyModal(resolve);
        });
        return promise;
    }

    private _configureNotifyModal(resolve: (x: boolean) => any) {
        let confirmed = (e: any) => resolve(true);
        this._confirmBtn.onclick = ((e: any) => {
            e.preventDefault();
            confirmed(e);
            $('#notifyInfo').modal('hide');
        });

        this._closeBtn.onclick = ((e: any) => {
            e.preventDefault();
            confirmed(e);
            $('#notifyInfo').modal('hide');
        });

    }
}
